'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var styles$b = require('./styles-d2f31ec6.js');

var TitleBlock = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, size = _a.size, spacing = _a.spacing, className = _a.className;
    return (React__default.createElement(styles$b.Container, { className: className },
        React__default.createElement(styles$b.Title, { className: "title", size: size }, title),
        subtitle && (React__default.createElement(styles$b.Subtitle, { className: "subtitle", spacing: spacing }, subtitle))));
};

exports.TitleBlock = TitleBlock;
